import React, { FunctionComponent } from 'react';
import styled, { css } from 'styled-components';

interface IProgress {
  main?: boolean;
  percentComplete: number;
  progress?: boolean;
}

export const Progress: FunctionComponent<IProgress> = ({
  main,
  percentComplete = '0',
  progress,
}) => {
  return (
    <ProgressWpapper progress={progress}>
      {progress ? (
        <TitleProgress>Progress {percentComplete}%</TitleProgress>
      ) : (
        <Title main={main}>{percentComplete}% Complete</Title>
      )}
      <ProgressLineWpapper progress={progress}>
        <ProgressLine width={percentComplete} progress={progress} />
      </ProgressLineWpapper>
    </ProgressWpapper>
  );
};

interface IProgressWpapper {
  progress?: boolean;
}

const ProgressWpapper = styled.div<IProgressWpapper>`
  ${({ progress, theme: { Consts } }) => css`
    width: 100%;
    display: flex;
    flex-direction: ${progress ? 'row' : 'column'};
    gap: ${progress ? '0' : '5px'};
    position: ${progress && 'relative'};
    height: ${progress && '24px'};
    border-top-right-radius: ${progress && '8px'};
    border-top-left-radius: ${progress && '8px'};
    overflow: ${progress && 'hidden'};
  `}
`;

interface ITitle {
  main?: boolean;
}

const Title = styled.h4<ITitle>`
  ${({ main, theme: { Consts } }) => css`
    font-weight: ${main ? 800 : 300};
    font-size: ${main ? '14px' : '12px'};
    line-height: ${main ? '20px' : '17px'};
    color: #ffffff;
  `}
`;
const TitleProgress = styled.p`
  ${({ theme: { Consts } }) => css`
    font-weight: 300;
    font-size: 13px;
    line-height: 20px;
    color: #ffffff;
    position: absolute;
    left: 19.5px;
    top: 2px;
  `}
`;
const ProgressLineWpapper = styled.div<IProgressWpapper>`
  ${({ progress, theme: { Consts } }) => css`
    width: 100%;
    display: flex;
    height: ${progress ? '100%' : '5px'};
    background: ${!progress && 'rgba(255, 255, 255, 0.5)'};
    border-top-right-radius: ${progress ? '8px' : '10px'};
    border-top-left-radius: ${progress ? '8px' : '10px'};
    border-bottom-right-radius: ${progress ? '0' : '10px'};
    border-bottom-left-radius: ${progress ? '0' : '10px'};
    overflow: hidden;
  `}
`;

interface IProgressLine {
  width: string | number;
  progress?: boolean;
}

const ProgressLine = styled.div<IProgressLine>`
  ${({ progress, width, theme: { Consts } }) => css`
    width: ${width}%;
    height: 100%;
    background: ${progress ? '#21B7BB' : '#b0dfd6'};
    border-radius: ${progress ? '0' : '10px'};
  `}
`;
